"use strict";

// `var` is kept as a conservative surface, but this file is NOT ES5: it uses
// `for…of` (L36), `.includes` (L53/56) and `?.` (L64), inside a bundle whose
// baseline is ES6+/ES2020 (see LEARNED.md, 2026-09-28).
var CHROME_EXTENSION = "chrome-extension";
var staticData = require("client/static_data");

var url = staticData.base_url + "/error"
function _log (text) {
    var newXHR;
    try {
        newXHR = new XMLHttpRequest();
    } catch (e) {
        try {
            newXHR = new ActiveXObject('Msxml2.XMLHTTP');
        } catch (e) {
            try {
                newXHR = new ActiveXObject('Microsoft.XMLHTTP');
            } catch (e) {
                return;
            }
        }
    }
    newXHR.open( 'POST', url );
    // newXHR.setRequestHeader("csrf-token", getCookie(CSRF_TOKEN_KEY));
    newXHR.setRequestHeader('Content-Type', 'text/plain');
    newXHR.setRequestHeader('x-requested-with', 'XMLHttpRequest');
    newXHR.send( text );
}


function _getPayload () {
    var payload = {};
    try {
        var fields = document.querySelectorAll("swiftref-input");
        for (var field of fields) {
            if (field.value) {
                payload[field.getAttribute("name")] = field.value;
            }
        }
        var country = document.querySelector('swiftref-dropdown[name="country_code"]');
        if (country.value) {
            payload[country.getAttribute("name")] = country.value;
        }

    } catch (e) {}

    return payload;
}


function _isChromeExtensionError (source, stack) {
    if (source && typeof source === "string" && source.includes(CHROME_EXTENSION)) {
        return true;
    }
    if (stack && typeof stack === "string" && stack.includes(CHROME_EXTENSION)) {
        return true;
    }
    return false;
}

function _onError (event, source, lineno, colno, error) {

    var stack = event.reason?.stack || error?.stack || "";
    var url = window.location.href;
    /**
     * Filter out false positive errors without "error" fifth parameter (old browsers,
     * error originated from js files served from a different origin).
     * @example:
     * - Script error.
     * - SyntaxError: Unexpected token '<'
     *
     * @author Simone Sacchi
     * @version 2023/02/24
     */
    if (event && event === "Script error.") {
        return;
    }

    /**
     * Filter error from the "chrome-extension"
     *
     * @author Simone Sacchi
     * @version 2023/02/24
     */
    if (_isChromeExtensionError(source, stack)) {
        return;
    }

    /**
     * Filter out errors raised by scripts INJECTED into the document: browser
     * extensions and app webviews add their own inline scripts, and the browser
     * blames the DOCUMENT url for them (WebKit) or reports an EMPTY source
     * (Blink, for a script inserted at runtime and for eval'd code). This app's
     * own code always arrives in a hashed bundle, so an error attributed to
     * neither a script file nor any other url is injected code. Those scripts
     * read their own markers off every page they load, e.g. TrueMoney's
     * `document.querySelector('#tmn-hide-navbar').innerHTML`.
     * Caveat: the markup carries no inline script today (the bundle is the only
     * script and no view has an inline handler); inline code added later —
     * parsed into the markup or inserted at runtime — would lose its own errors
     * here too.
     * Only an EXPLICITLY empty source is dropped: an unhandled rejection carries
     * no source at all (undefined) and must stay reported.
     *
     * @example source "" (Blink, a script inserted at runtime)
     * @example source "https://www.swiftref.com/en/bicsearch" (WebKit, line 1, col 43)
     * @see LEARNED.md
     */
    if (source === "") {
        return;
    }
    if (source && typeof source === "string" &&
        source.split("#")[0].split("?")[0] === url.split("#")[0].split("?")[0]) {
        return;
    }

    /**
     * filter-out errors from browser not supporting web-components. User will see
     * a message
     */
    if (url.includes("unsupported")) {
        return;
    }
    /**
     * Filter out "EvalError" due to external code (public pages code do not use eval)
     */
    if (error && error instanceof EvalError) {
        return;
    }
    if (event === "TypeError: undefined is not an object (evaluating 'a.L')") {
        return;
    }

    var message = event.reason ? 'Unhandled Promise Rejection: ' + event.reason : event;

    var data = {
        message: message,
        source: source,
        line: lineno,
        column: colno,
        stack: stack,
        url: url,
        payload: _getPayload()
    };
    var payload = JSON.stringify(data);
    _log(payload);

    return false;
}

window.onerror = _onError;
window.addEventListener('unhandledrejection', _onError);
